import { Link } from "react-router-dom";
import { categories } from "@/mocks/works";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-12 md:py-16" aria-label="作品分类">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="作品分类"
          title="按喜好浏览漫画"
          desc="丰富的分类体系，总有一个类型戳中你的喜好，轻松找到对胃口的作品。"
          align="center"
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/works?cat=${cat.id}`}
              className="group flex items-center gap-4 rounded-xl bg-background-50 border border-background-200 p-4 transition-all hover:-translate-y-1 hover:border-primary-200 md:p-5"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-2xl text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 md:h-14 md:w-14 md:text-[28px]">
                <i className={cat.icon} />
              </span>
              <div className="min-w-0">
                <h3 className="font-heading text-base font-bold text-foreground-900 md:text-lg">{cat.name}</h3>
                <p className="mt-0.5 truncate text-xs text-foreground-500 md:text-sm">{cat.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line ml-auto text-xl text-foreground-300 group-hover:text-primary-500" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}